import { AdditionalOrderInfoActions } from "@electricMotorShop/Store/AdditionalOrderInfomationReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<AdditionalOrderInfoActions>;

type HandlerType = Handler<{
    additionalOrderEmail?: string;
}, Props>;

export const DispatchSetAdditionalOrderInfo: HandlerType = props => {
    props.dispatch({
       type: "Custom/AdditionalOrderInfo/SetAdditionalOrderInfo",
        additionalOrderEmail: props.parameter.additionalOrderEmail,
    });
};

export const chain = [DispatchSetAdditionalOrderInfo];

const setAdditionalOrderInfo = createHandlerChainRunner(chain, "SetAdditionalOrderInfo");
export default setAdditionalOrderInfo;
